import React from 'react';

export function AdicaoLinhaCuidado({ modalData }) {
  return (
    <div>
      <div>
        <span>CNES</span>
        <p>{modalData && modalData.cnes}</p>
      </div>

      <div>
        <span>Instituição</span>
        <p>{modalData && modalData.fantasyName}</p>
      </div>
      <div>
        <span>Responsável</span>
        <p>{modalData && modalDataResponsavel.nomeUsuario}</p>
      </div>

      <div>
        <span>E-mail</span>
        <p>{modalData && modalDataResponsavel.email}</p>
      </div>
    </div>
  );
}
